import React from "react";
import { Alert, Box } from "@showitinc/showit-wc";

import AnimationProperties from "./AnimationProperties";
import { TRANSITION_IN } from "../constants/AnimationConstants";
import { GROUP } from "@/constants/DataTypes";
import HelpConstants from "../constants/HelpConstants";

/**
 * Renders a notice that animations set on elements within a group will not work. Animations set on the group itself will still work.
 */
const GroupChildAnimationNotice = () => (
  <Box my="2" data-testid="group-child-animation-warning">
    <Alert
      variant="info"
      stacked
      weight="bold"
      message="Animations set on elements within a group will not work. Animations set on the group itself will still work."
      ctaText="Learn More"
      ctaLink={HelpConstants.URL_GROUP_CHILD_ELEMENT_ANIMATIONS}
    />
  </Box>
);

/**
 * @param {Object} props
 * @param {import("immutable").Map} props.element
 * @param {string} props.layout
 * @param {boolean} props.isLocked
 * @param {function} props.onPropUpdate
 */
const ElementPropertiesAnimation = ({
  element,
  layout,
  isLocked,
  onPropUpdate,
}) => {
  const _onAnimationChange = (propInfo) => {
    onPropUpdate && onPropUpdate(propInfo);
  };

  const showGroupChildAnimationWarning =
    element.get("type") !== GROUP && element?.get?.("pId");

  if (showGroupChildAnimationWarning) {
    return <GroupChildAnimationNotice />;
  }

  const elemProps = element.get(layout);
  const tran = elemProps.get(TRANSITION_IN);

  return (
    <AnimationProperties
      isLocked={isLocked}
      container={element}
      layout={layout}
      transitionType={TRANSITION_IN}
      tran={tran}
      propPrefix={layout}
      onPropUpdate={_onAnimationChange}
    />
  );
};

export default ElementPropertiesAnimation;